import { IBaseAction } from '../../constants';

//************* */

export const DOWNLOAD_EXCEL_SUCCESS = 'DOWNLOAD_EXCEL_SUCCESS';
export const DOWNLOAD_EXCEL_FAILURE = 'DOWNLOAD_EXCEL_FAILURE';
export const DOWNLOAD_EXCEL = 'DOWNLOAD_EXCEL';
export interface DownloadExcelAction extends IBaseAction {
  type: typeof DOWNLOAD_EXCEL | typeof DOWNLOAD_EXCEL_SUCCESS | typeof DOWNLOAD_EXCEL_FAILURE,
  payload?: {
    data: {
      data: any,
      headers: any
    }
  }
}

export type FlightsActionTypes = DownloadExcelAction;